export interface CodeBlock {
  source: string;
  language: string;
}
